module.exports = __webpack_public_path__ + "img/global_ban.png";